/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectBatchResponse {
    getFixupPrototypeFunction() { return AppSecopsProjectBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectBatchResponse>): AppSecopsProjectBatchResponse {
        let obj = Object.assign(new AppSecopsProjectBatchResponse(), model);
        AppSecopsProjectBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectBatchResponse>): AppSecopsProjectBatchResponse {
        if (!model) return null;
        return AppSecopsProjectBatchResponse.newInstance(<AppSecopsProjectBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectBatchResponse) {
        if (!obj) return;

        models.AppSecopsProjectBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectBatchResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsProjectBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AppSecopsProject.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AppSecopsProject; };

}
